const __DEV__ = false;

var data = { colors:{ common:{ black:"#000",
      white:"#fff" },
    navy:{ "100":"#EAEFF3",
      "200":"#C6CFDC",
      "300":"#99A6B7",
      "400":"#6C7D95",
      "500":"#475D7A",
      "600":"#394A62" },
    gray:{ "200":"#FAFAFA",
      "300":"#F5F5F5",
      "400":"#E8E8E8",
      "500":"#D9D9D9",
      "600":"#BFBFBF",
      "700":"#8C8C8C",
      "800":"#595959",
      "900":"#262626" },
    blue:{ "100":"#CCE8F4",
      "300":"#66BBDF",
      "500":"#008DCA" },
    green:{ "100":"#D3E6CC",
      "200":"#A7CE99",
      "300":"#7BB566",
      "400":"#4F9C33",
      "500":"#238400",
      "600":"#1C6900" },
    purple:{ "100":"#E8E2FA",
      "200":"#D1C5F4",
      "300":"#BAA8EF",
      "400":"#A38BE9",
      "500":"#8C6EE4",
      "600":"#7058B6" },
    orange:{ "100":"#F8E6D4",
      "200":"#F1C59A",
      "300":"#EAA868",
      "400":"#E38B36",
      "500":"#DC6E04",
      "600":"#B05803" },
    red:{ "100":"#F1E1DE",
      "200":"#DEB2AB",
      "300":"#CE8C81",
      "400":"#BD6557",
      "500":"#AD3F2D",
      "600":"#8A3224" },
    brand:{ blue:"#2F7699",
      red:"#FF585D",
      navy:"#475D7A",
      deepNavy:"#253746",
      lightGray:"#E5E1E5",
      darkGray:"#434143" },
    overlay:"rgba(0, 0, 0, 0.65)",
    shadow:"rgba(0, 0, 0, 0.65)",
    primary:{ "100":"#EAEFF3",
      "200":"#C6CFDC",
      "300":"#99A6B7",
      "400":"#6C7D95",
      "500":"#475D7A",
      "600":"#394A62" },
    accent:{ "200":"#FAFAFA",
      "300":"#F5F5F5",
      "400":"#E8E8E8",
      "500":"#D9D9D9",
      "600":"#BFBFBF",
      "700":"#8C8C8C",
      "800":"#595959",
      "900":"#262626" } } };

var colors = data;

export { colors as default };
//# sourceMappingURL=colors.yaml.js.map
